export enum ImportPlanViews {
  ERROR = 'error',
  PENDING = 'pending',
  UPLOAD = 'upload',
}

export type ImportErrorItem = {
  mediaRowId: string | null;
  mediaRowName: string;
  error: string;
};
